import {createUseStyles} from 'react-jss';

export default createUseStyles({
  addAddressLabel: {
    cursor: 'pointer',
    lineHeight: 'inherit',
    fontWeight: props => props.theme.core.boldFontWeight,
  },
  icon: props => ({
    float: 'left',
    width: '1.4em',
    height: '1.4em',
    marginRight: 6,
    transition: 'transform 0.2s, width 0.2s, margin-right 0.3s',
    
    ...(props.isSelected) && {
      transition: 'transform 0.5s, width 0.3s linear 0.2s, margin-right 0.3s linear 0.2s',
      width: 0,
      marginRight: 0,
      transform: 'rotate(90deg) scale(0)',
    },
  }),
});
